import { createContentSetContributorsQuery } from "./content-set"
import { createDrilldownContributorsQuery } from "./drilldown-helpers"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export function createDrilldownContentSetContributorsQuery({
  selectedFactor,
  selectedCategory,
  ...options
}: ContributorsQueryOptions) {
  const categoryOptions = selectedCategory ? { ...options, category: selectedCategory } : options
  const factorIds = selectedFactor ? [selectedFactor] : []
  return createDrilldownContributorsQuery(createContentSetContributorsQuery, factorIds, categoryOptions)
}

export function createContentSetDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  selectedCategory,
  classifications,
  contentSetId,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & {
  selectedFactor?: string
  selectedCategory?: string
  contentSetId: string
}) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    instrumentSuffix,
  })
  const contentSetGatherer = createDrilldownContentSetContributorsQuery({
    ...coreOptions,
    prefix: `${contentSetId}${instrumentSuffix}`,
    contentSetId,
    from: startDate,
    to: endDate,
    selectedFactor,
    selectedCategory,
  })
  return [...baseGatherers, contentSetGatherer]
}
